import './DictpickerModal.scss';
import { portalOverlayClassName } from '@srm/ui/lib/portalOverlay';
import { FC, useState } from 'react';
import clsx from 'clsx';
import Button from '@srm/ui/button';
import Modal from '@srm/ui/modal';
import SearchModeControl from './ModeControls/SearchModeControl';
import { IExternalSearchDict } from '@models/Forms/IForms';
import { DictionariesService } from '@services/DictionariesService';
import { sendModalMsg } from '@srm/ui/lib/modalMessages';
import { IModalMessageButton } from '@srm/ui/message-modal';

export interface IDictExternalSearchModalProp {
    settings: IExternalSearchDict;
    onClose: () => void;
    onSubmit: (data: string) => void;
    //getParams: (options: any) => string;
}

const DictExternalSearchModal: FC<IDictExternalSearchModalProp> = (p: IDictExternalSearchModalProp) => {
    const [selectedRowItem, setSelectedRowItem] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);

    const ModalFooter = ({ onClose, onSubmit }: { onClose: () => void; onSubmit: (data: any) => void }) => (
        <div className={'dictModal_footer'}>
            <Button
                disabled={selectedRowItem == undefined || loading}
                onClick={() => {
                    if (selectedRowItem) {
                        setLoading(true);
                        DictionariesService.saveExternalSearch(p.settings.submitApiUrl, selectedRowItem)
                            .then((response) => {
                                if (response.data.message) {
                                    if (p.settings.errorMessages && p.settings.errorMessages.errorMessage) {
                                        const conf = p.settings.errorMessages.errorMessage.find(
                                            (x) => x.errorValue === response.data.message,
                                        );
                                        if (conf) {
                                            const buttons: IModalMessageButton[] = [];
                                            conf?.buttons?.forEach((x) => {
                                                const url = x.act.replace('{payload}', response.data.payLoadId);
                                                buttons.push({
                                                    title: x.title,
                                                    onClick: () => {
                                                        window.open(`.${url}`, '_blank');
                                                    },
                                                });
                                            });
                                            sendModalMsg({
                                                message: [conf.message],
                                                type: 'error',
                                                closeBtnTitle: conf.closeBtnTitle,
                                                buttons: buttons,
                                                closeBtnClick: () => {
                                                    onSubmit(response.data.payLoadKey);
                                                    onClose();
                                                },
                                            });
                                        } else {
                                            sendModalMsg({
                                                message: [response.data.message],
                                                type: 'error',
                                                closeBtnClick: () => {
                                                    onSubmit(response.data.payLoadKey);
                                                    onClose();
                                                },
                                            });
                                        }
                                    } else {
                                        sendModalMsg({
                                            message: [response.data.message],
                                            type: 'error',
                                            closeBtnClick: () => {
                                                onSubmit(response.data.payLoadKey);
                                                onClose();
                                            },
                                        });
                                    }
                                } else {
                                    onSubmit(response.data.payLoadKey);
                                    onClose();
                                }
                            })
                            .finally(() => {
                                setLoading(false);
                            });
                    } else {
                        onClose();
                    }
                }}
                size="sm"
            >
                Выбрать
            </Button>
            <Button onClick={onClose} variant="light" size="sm">
                Отменить
            </Button>
        </div>
    );

    return (
        <Modal
            className={clsx('dictExternalSearchModal', portalOverlayClassName)}
            size="content"
            onClose={p.onClose}
            closeDisabled={loading}
            hasUnsavedInput={() => Boolean(selectedRowItem)}
            footer={<ModalFooter onClose={p.onClose} onSubmit={p.onSubmit} />}
            header={p.settings.buttonName}
        >
            <div className="dict-container">
                <div className="dict-grid">
                    <SearchModeControl
                        {...p.settings}
                        onSelectedRowItems={(data) => {
                            setSelectedRowItem(data);
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default DictExternalSearchModal;
